module.exports = __webpack_public_path__ + "img/icon_mail_dot.6cd4f6d5.svg";